// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const config = {
	firebaseConfig : {
		apiKey: "AIzaSyCTEcAT66EP4P4qOA46uVjEFzk_YhLtGIc",
		authDomain: "edc-powerplantc7.firebaseapp.com",
		projectId: "edc-powerplantc7",
		storageBucket: "edc-powerplantc7.appspot.com",
		messagingSenderId: "489519390303",
		appId: "1:489519390303:web:aad719ad25e2355c1585ea"
	},

	baseUrl: 'https://edc-powerplantc7-rhvgtpasbq-as.a.run.app'
}

// Initialize Firebase